"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var clamp = function (a, min, max) {
    if (a < min) {
        return min;
    }
    else if (a > max) {
        return max;
    }
    return a;
};
exports.default = clamp;
//# sourceMappingURL=clamp.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/clamp.js
// module id = 1086
// module chunks = 37